// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__ifhDq","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1_Y0A"};